import { _tenant } from "@/state";
import { ModelDefaults } from "@/state/ModelDefaults";
import { obj } from '@/util'

export class Tenant {

    /*
    |-------------------------------------------------------------
    | Data
    |-------------------------------------------------------------
    */
	
	state = () => _tenant()
	setState = (data = {}) => (Object.assign(this.state(), this.commit(data)))
	
	static stateDefaults = () => Object.assign({},
		ModelDefaults.Tenant(),
		{
			coin_counts: {},
			integrations : {}
		}
	)
	
	commit = (data = {}) => {
		if (data !== false) {
			let original = Object.assign(this.constructor.stateDefaults(), this);
			Object.assign(this, original, data);
			this.computedData();
			return obj.cleanCopy(this);
		}
		return this.constructor.stateDefaults()
	}

	computedData = () => {}

    /*
    |-------------------------------------------------------------
    | Authentication
    |-------------------------------------------------------------
    */

	tenantIsSubscribed = () => (!!this.state().subscribed)

    /*
    |--------------------------------------------------------------------------
    | GAME Coins
    |--------------------------------------------------------------------------
    */

	coins = () => this.state().coin_counts || {}

	earntCoins = () => this.coins().earnt || null

	spentCoins = () => this.coins().spent || null

    /*
    |--------------------------------------------------------------------------
    | Integration
    |--------------------------------------------------------------------------
    */

	getIntegrations = () => this.state().integrations || {}

	getConnector = () => this.getIntegrations().connector || null

}